import React from 'react';

import { Chip, Stack, Typography } from '@mui/material';

import { type ComparisonVariantRow, isMetricResultUnreliable } from './marketingRouterComparison';
import { formatConfidence } from './marketingRouterSignificanceDisplay';

export default function MarketingRouterComparisonConfidenceCell({ row }: { row: ComparisonVariantRow }) {
  if (row.result === null) {
    return <Typography variant="body2">—</Typography>;
  }
  // The verdict is still whatever the test produced, but svc-promo has said
  // the reading behind it is invalid, so it is never shown as a win here.
  if (isMetricResultUnreliable(row.result)) {
    return (
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography variant="body2" color="text.secondary">
          {formatConfidence(row.result)}
        </Typography>
        <Chip label="Unreliable" color="error" size="small" />
      </Stack>
    );
  }

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography variant="body2" sx={{ fontWeight: row.result.verdict === 'SIGNIFICANT' ? 600 : 400 }}>
        {formatConfidence(row.result)}
      </Typography>
      {row.result.verdict === 'SIGNIFICANT' ? (
        <Chip label="Significant" color={row.result.absoluteLift >= 0 ? 'success' : 'error'} size="small" />
      ) : null}
      {row.result.verdict === 'COLLECTING' ? <Chip label="Collecting" color="info" size="small" /> : null}
    </Stack>
  );
}
